import { render, staticRenderFns } from "./IndexProdItem.vue?vue&type=template&id=5a78c5e4&scoped=true"
import script from "./IndexProdItem.vue?vue&type=script&lang=js"
export * from "./IndexProdItem.vue?vue&type=script&lang=js"
import style0 from "./IndexProdItem.vue?vue&type=style&index=0&id=5a78c5e4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a78c5e4",
  null
  
)

export default component.exports